import { Injectable, NgZone } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { User } from 'firebase';
import { AngularFirestore } from '@angular/fire/firestore';
import { Toast } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private authService:AuthService,
    private router:Router,
    private firestore: AngularFirestore
  ) { }

  canActivate(route:ActivatedRouteSnapshot,state:RouterStateSnapshot) {
    return this.checkActivate()
  }

  async checkActivate(){
    const user:User = await this.authService.checkAuth().then(result=>{
      return result
    })

    console.log("user"+user);
    if (user){
      if (user.providerData[0].providerId === 'facebook.com'){
        // Facebook
        var isExistStudent = await this.checkExistStudent(user.uid)
        if(!isExistStudent){
          this.router.navigate(['fb-register']);
          return false;
        }
        // if (!user.photoURL){
        //   this.router.navigate(['update-photo']);
        //   return false;
        // }
        return true;
      }else{
        // Other
        const isOtpVerified = await this.authService.isUserVerified(user.uid);
        if (!isOtpVerified) {
          this.router.navigate(['verify-email']);
          return false;
        }
        // if (!user.photoURL){
        //   this.router.navigate(['update-photo']);
        //   return false;
        // }
        return true;
      }
    }else{
      if (!user){
        this.router.navigate(['login']);
        return false;
      }
    }
    
  }

  async checkExistStudent(uid:string):Promise<boolean>{
    let promise:Promise<boolean> = new Promise((resolve, reject) => {
     
      this.firestore.collection('students').doc(uid).get().subscribe(queriedItem => {
        if (queriedItem.data()) {
          resolve(true)
        } else {
          resolve(false)
        }
        console.log(queriedItem.data())
      })
    
    });
    return promise;
    
  }

  

  
}
